var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.773 144.773",
    style: {
      enableBackground: "new 0 0 144.773 144.773"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 145,
    style: {
      fill: "#10303F"
    },
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 145,
    id: "SVGID_1_",
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EC9A1C"
    },
    cx: 72.387,
    cy: 62.721,
    rx: 29.635,
    ry: 29.828
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M107.053,116.94c-4.666-8.833-34.666-14.376-34.666-14.376s-30,5.543-34.666,14.376 c-3.449,12.258-6.334,27.833-6.334,27.833h41h41C113.387,144.773,111.438,128.073,107.053,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.387,102.564c0,0,30,5.543,34.666,14.376c4.386,11.133,6.334,27.833,6.334,27.833h-41V102.564z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.22,
    y: 84.606,
    style: {
      fill: "#F1C9A5"
    },
    width: 16.334,
    height: 27.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.387,
    y: 84.606,
    style: {
      fill: "#E4B692"
    },
    width: 8.167,
    height: 27.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C"
    },
    d: "M64.22,97.273c1.469,4.217,7.397,6.634,11.751,6.634c1.575,0,3.107-0.264,4.583-0.747 V84.606H64.22V97.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783c-11.598,0-21,9.709-21,26.783 c0,17.074,9.402,30.917,21,30.917C83.984,98.274,93.387,84.432,93.387,67.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M90.19,79.195c-3.807-0.424-6.377-4.783-5.732-9.732c0.637-4.953,4.242-8.63,8.051-8.209 c3.805,0.422,6.371,4.779,5.729,9.732C97.599,75.939,93.997,79.613,90.19,79.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M46.685,70.986c-0.643-4.953,1.924-9.311,5.727-9.732c3.81-0.421,7.416,3.256,8.055,8.209 c0.642,4.949-1.93,9.309-5.734,9.732C50.925,79.613,47.323,75.939,46.685,70.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783v57.7C83.984,98.274,93.387,84.432,93.387,67.357z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC611F"
    },
    d: "M107.053,116.94c-1.565-2.964-5.987-5.555-11.166-7.692c-2.604,10.561-12.136,18.394-23.5,18.394 c-11.364,0-20.896-7.833-23.5-18.394c-5.179,2.138-9.601,4.729-11.166,7.692c-3.449,12.258-6.334,27.833-6.334,27.833h41h41 C113.387,144.773,111.438,128.073,107.053,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC9A1C"
    },
    d: "M72.387,37.698c0,0-28.662,2.166-23.334,26.922c0,0,27.048-4.97,31.302-15.38 c4.254,10.41,15.366,15.38,15.366,15.38C101.049,39.864,72.387,37.698,72.387,37.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC9A1C"
    },
    d: "M49.231,78.095c0,0-10.18,1.454-17.159,14.979c4.07,1.165,5.815,1.745,9.598,2.036 c1.309,4.072,5.816,5.527,5.816,5.527s7.315-6.892,5.716-16.78"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC9A1C"
    },
    d: "M95.541,78.095c0,0,10.18,1.454,17.159,14.979c-4.07,1.165-5.815,1.745-9.598,2.036 c-1.31,4.072-5.816,5.527-5.816,5.527s-7.315-6.892-5.716-16.78"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.4948df13a2e0cb0484a56ad5d647a6ba.svg";
export { ForwardRef as ReactComponent };